import { render, staticRenderFns } from "./airdropReceiveRecord.vue?vue&type=template&id=5aa12e7d&scoped=true"
import script from "./airdropReceiveRecord.vue?vue&type=script&lang=js"
export * from "./airdropReceiveRecord.vue?vue&type=script&lang=js"
import style0 from "./airdropReceiveRecord.vue?vue&type=style&index=0&id=5aa12e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa12e7d",
  null
  
)

export default component.exports